import {
  AlignHorizontalDistributeCenter,
  AlignVerticalDistributeCenter,
  ArrowDownToLine,
  ArrowLeft,
  AudioLines,
  Camera,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleHelp,
  Clock3,
  Copy,
  ExternalLink,
  Eye,
  EyeOff,
  Gift,
  Hand,
  Heart,
  Image,
  Layers,
  LayoutGrid,
  LockKeyhole,
  Menu,
  MessageCircle,
  Monitor,
  Mic,
  Minus,
  MousePointer2,
  Palette,
  PanelsTopLeft,
  Play,
  Plus,
  Plug,
  Radio,
  Redo2,
  RotateCw,
  Search,
  Settings2,
  Smile,
  Square,
  SquarePen,
  Star,
  Trash2,
  Type,
  Undo2,
  UserRound,
  Workflow,
  X,
  Zap,
} from '@lucide/vue'
import type { AppIconOverrides } from '@repo/ui'

// AppIcon remains the shared renderer, including icons inside library controls.
// Named imports keep the dashboard's icon family out of other apps and OBS output.
// Brand marks (Twitch, Discord) and the Chaotee avatar placeholder retain their original artwork.
export const streamerIcons = {
  arrowsExpandHorizontal: AlignHorizontalDistributeCenter,
  arrowLeftOutline: ArrowLeft,
  arrowLeftSimple: ArrowLeft,
  avatarOutline: Smile,
  broadcast: Radio,
  camera: Camera,
  chat: MessageCircle,
  checkCircleAlt: CircleCheck,
  checkCircleFill: CircleCheck,
  checkCircleOutline: CircleCheck,
  checkSimple: Check,
  chevronDown: ChevronDown,
  chevronDownIcon: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronRightIcon: ChevronRight,
  chevronUp: ChevronUp,
  clockOutline: Clock3,
  cog: Settings2,
  connection: Plug,
  computerDesktop: Monitor,
  copyOutlineAlt: Copy,
  copyOutline: Copy,
  cursorArrow: MousePointer2,
  downloadOutline: ArrowDownToLine,
  edit: SquarePen,
  externalLink: ExternalLink,
  eye: Eye,
  eyeOff: EyeOff,
  gallery: Image,
  galleryOutline: Image,
  gift: Gift,
  handPan: Hand,
  heart: Heart,
  home: PanelsTopLeft,
  layersOutline: Layers,
  lightningBolt: Zap,
  lock: LockKeyhole,
  menu: Menu,
  microphone: Mic,
  minus: Minus,
  overlay: PanelsTopLeft,
  paletteOutline: Palette,
  play: Play,
  plus: Plus,
  questionMarkCircle: CircleHelp,
  redo: Redo2,
  refresh: RotateCw,
  search: Search,
  sortVertical: AlignVerticalDistributeCenter,
  squareOutline: Square,
  star: Star,
  tableGrid: LayoutGrid,
  trash: Trash2,
  typeOutline: Type,
  undo: Undo2,
  user: UserRound,
  wandMagicSparkles: Workflow,
  waveform: AudioLines,
  xMark: X,
} satisfies AppIconOverrides
